import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type {
  ApiError,
  MongoSaveRequest,
  MongoSaveResponse,
  MongoListResponse,
  MongoStatusResponse,
} from '../types/showcase';

/**
 * GET /api/eraf/showcase/demo/mongo/status — C054 상태 조회
 * queryKey: ['common-showcase', 'mongo', 'status']
 */
export function useMongoStatus() {
  return useQuery<MongoStatusResponse, ApiError>({
    queryKey: ['common-showcase', 'mongo', 'status'],
    queryFn: () => showcaseApi.mongoStatus(),
    staleTime: 15_000,
  });
}

/**
 * GET /api/eraf/showcase/demo/mongo/list?limit=20 — 저장 문서 목록 조회
 * queryKey: ['common-showcase', 'mongo', 'list', limit]
 * enabled: false — save 성공 후 자동 1회 재조회 + 수동 [재조회] 버튼으로 트리거
 */
export function useMongoList(limit = 20) {
  return useQuery<MongoListResponse, ApiError>({
    queryKey: ['common-showcase', 'mongo', 'list', limit],
    queryFn: () => showcaseApi.mongoList(limit),
    enabled: false,
  });
}

/**
 * POST /api/eraf/showcase/demo/mongo/save — 문서 저장
 * 성공 시 status 캐시 무효화 (docCount 등 갱신)
 */
export function useMongoSave() {
  const queryClient = useQueryClient();
  return useMutation<MongoSaveResponse, ApiError, MongoSaveRequest>({
    mutationFn: (req) => showcaseApi.mongoSave(req),
    mutationKey: ['common-showcase', 'mongo', 'save'],
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['common-showcase', 'mongo', 'status'] });
    },
  });
}
